module.exports = __webpack_public_path__ + "media/images/top/feature01-85b3678017af1742b24f03ad0eb7ce41.jpg";